export const prefix = (p: string, s: string) => {
  return `[${p}] : ${s}`;
};
